// Module Import
//---------------------------------
import React, { useState } from 'react'
import styled from 'styled-components'
import { StaticImage } from 'gatsby-plugin-image'
import TypographyAtom from '../../atoms/typography/typography'
import { brandIvory, brandOrange, brandWhite } from '../../../assets/consts/color'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const AccordionHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 48px;
  justify-content: space-between;
  padding: 24px;
  width: 100%;
  border-bottom: 2px solid ${brandIvory};
  cursor: pointer;

  H3 {
    margin: 0;
  }
`

const AccordionBody = styled.div`
  padding: 24px;

  p {
    margin-bottom: 16px;
  }
`

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  padding: 4px;
  transition:
    background-color 0.25s ease-in-out,
    border 0.25s ease-in-out;

  &.icon-open {
    transform: rotate(180deg);
    border: 1px solid ${brandOrange};
    background-color: ${brandWhite};
  }

  &.icon-close {
    background-color: ${brandOrange};
    border: 1px solid transparent;
  }
`

const closed = {
  display: 'none',
}

const open = {
  display: 'block',
}

// Component Export
//---------------------------------
export default function TermsAndConditionsAccordion({ header, body }) {
  const [isOpen, setIsOpen] = useState(false)
  const changeAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <AccordionWrapper
      onClick={() => {
        changeAccordion()
      }}
    >
      <AccordionHeader>
        <TypographyAtom type="H3" copy={header} weight="Thin" />
        <Icon className={isOpen ? 'icon-open' : 'icon-close'}>
          {!isOpen ? (
            <StaticImage
              src="../../../assets/images/down_arrow_white.svg"
              width={150}
              height={75}
              alt="Section open"
            />
          ) : (
            <StaticImage
              src="../../../assets/images/down_arrow_orange.svg"
              width={150}
              height={75}
              alt="Section close"
            />
          )}
        </Icon>
      </AccordionHeader>
      <AccordionBody style={isOpen ? open : closed}>
        <TypographyAtom type="BlockText" copyBlock={body} weight="BlockText" />
      </AccordionBody>
    </AccordionWrapper>
  )
}
